import { Grid, Divider } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { ImageUploadField } from 'components'

import { useStyles } from '../styles'
import { Style } from '../types'

interface AppMobileProps {
  style: Style
  setStyle: (style: Style) => void
  setLogoFile: (file: File | undefined) => void
  setHomeFile: (file: File | undefined) => void
  setBannerFile: (file: File | undefined) => void
  setNextEventsFile: (file: File | undefined) => void
  onSave: () => void
}

const AppMobile: React.FC<AppMobileProps> = ({
  style,
  setStyle,
  setHomeFile,
  setBannerFile,
  setNextEventsFile,
}) => {
  const classes = useStyles()

  const [primaryBackground, setPrimaryBackground] = useState<string>('')
  const [secondaryBackground, setSecondaryBackground] = useState<string>('')
  const [homePreview, setHomePreview] = useState<string>('')
  const [bannerPreview, setBannerPreview] = useState<string>('')
  const [nextEventsPreview, setnextEventsPreview] = useState<string>('')

  useEffect(() => {
    const { appColors } = style
    setPrimaryBackground(appColors.$PRIMARY_BACKGROUND)
    setSecondaryBackground(appColors.$SECONDARY_BACKGROUND)
    setHomePreview(style.homeUrl)
    setBannerPreview(style.bannerUrl)
    setnextEventsPreview(style.nextEventUrl)
  }, [style])

  useEffect(() => {
    style.appColors = {
      $PRIMARY_BACKGROUND: primaryBackground,
      $SECONDARY_BACKGROUND: secondaryBackground,
    }
    setStyle(style)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryBackground, secondaryBackground, style.appColors])

  const handleHomeChange = (file: File) => {
    setHomePreview(URL.createObjectURL(file))
    setHomeFile(file)
  }

  const handleBannerChange = (file: File) => {
    setBannerPreview(URL.createObjectURL(file))
    setBannerFile(file)
  }
  const handleNextEventsChange = (file: File) => {
    setnextEventsPreview(URL.createObjectURL(file))
    setNextEventsFile(file)
  }

  const handleHomeDelete = () => {
    setHomePreview('')
    setHomeFile(undefined)
  }
  const handleBannerDelete = () => {
    setBannerPreview('')
    setBannerFile(undefined)
  }

  const handleNextEventsDelete = () => {
    setnextEventsPreview('')
    setNextEventsFile(undefined)
  }

  return (
    <>
      {/* <Grid container alignItems="flex-end" className={classes.dividerContainer}>
        <span className={classes.dividerText}>COLOR</span>
        <Button
          onClick={reset}
          variant="outlined"
          color="primary"
          className={classes.resetButton}
          startIcon={<RotateCcw size={20} className={classes.resetIcon} />}
        >
          Resetear
        </Button>
      </Grid>
      <Divider className={classes.divider} variant="fullWidth" />
      <Grid container item xs={12} style={{ marginBottom: 30 }}>
        <ColorPicker label="Primario" color={primaryBackground} handler={handlePrimaryBackgroundChange} />
        <ColorPicker label="Secundario" color={secondaryBackground} handler={handleSecondaryBackgroundChange} />
      </Grid> */}
      <Grid container alignItems="flex-end" className={classes.dividerContainer}>
        <span className={classes.dividerText}>Imágenes</span>
      </Grid>
      <Divider className={classes.divider} variant="fullWidth" />
      <Grid container spacing={3} style={{ marginBottom: 30 }}>
        <Grid item>
          <ImageUploadField
            id="styles-home-upload"
            label="Home"
            variant="wide"
            preview={homePreview}
            onChange={handleHomeChange}
            onDelete={handleHomeDelete}
          />
        </Grid>
        <Grid item>
          <ImageUploadField
            id="styles-banner-upload"
            label="Banner beneficios"
            variant="wide"
            preview={bannerPreview}
            onChange={handleBannerChange}
            onDelete={handleBannerDelete}
          />
        </Grid>
        <Grid item>
          <ImageUploadField
            id="styles-next-events-upload"
            label="Próximos eventos"
            variant="wide"
            preview={nextEventsPreview}
            onChange={handleNextEventsChange}
            onDelete={handleNextEventsDelete}
          />
        </Grid>
      </Grid>
    </>
  )
}

export { AppMobile }
